import { ATDLValidationGroupModel } from "app/order-entry/data-atdl/model/atdl-validation-group.model";
import { ATDLNOperator } from "../enums/atdl-operator.enum";
import { ATDLValidationRuleModel } from "app/order-entry/data-atdl/model/atdl-validation-rule.model";

export class ATDLInterfaceDependencyModel {
  public action: {
    visible: boolean;
    enabled: boolean;
    value: any;
  } = {
    visible: null,
    enabled: null,
    value: null,
  };

  public fieldOwner: string = null;
  public singleFieldDependency: string = null;
  public value: string = null;
  public operator: ATDLNOperator = null;

  public logicGroups: Array<ATDLValidationGroupModel> = null;
  public rules: Array<ATDLValidationRuleModel> = null;

  /** Lazily created  set of dependent field names*/
  private _dependentFields: Set<string>;

  constructor(fieldOwner?: string) {
    this.fieldOwner = fieldOwner;
  }

  /**
   * Set of all control names referenced by this model
   */
  public get fieldDependencies(): Set<string> {
    if (!this._dependentFields) {
      this.populateDependentFields();
    }
    return new Set(this._dependentFields);
  }

  /**
   * Does the dependendency reference the specified control name?
   * @param fieldName
   * @returns
   */
  public hasFieldDependency(fieldName: string): boolean {
    if (!this._dependentFields) {
      this.populateDependentFields();
    }
    return this._dependentFields.has(fieldName);
  }

  /**
   * Popuilate dependencies
   * @returns
   */
  private populateDependentFields() {
    this._dependentFields = new Set();
    if (this.singleFieldDependency) {
      this._dependentFields.add(this.singleFieldDependency);
      return;
    }

    this.addLogicGroupsDependentFields(this.logicGroups);
  }

  /**
   * Recurse through all nested groups and rules and add their references
   * to the set
   * @param logicGroups
   */
  private addLogicGroupsDependentFields(logicGroups: ATDLValidationGroupModel[]) {
    if (logicGroups?.length) {
      for (const logicGroup of logicGroups) {
        this.addLogicGroupsDependentFields(logicGroup.logicGroups);
        this.addLogicRulesDependentFields(logicGroup.rules);
      }
    }
  }
  private addLogicRulesDependentFields(rules: ATDLValidationRuleModel[]) {
    if (rules?.length) {
      for (const rule of rules) {
        this._dependentFields.add(rule.field);
        if (rule.field2) {
          this._dependentFields.add(rule.field2);
        }
      }
    }
  }
}
